import React, { useState } from 'react';
import Icon from '@/components/AppIcon';
import Button from '@/components/ui/Button';
import Input from '@/components/ui/Input';
import Select from '@/components/ui/Select';
import { ArrowLeft, Calendar, Clock, Building2, MapPin, DollarSign, Users, TrendingUp, FileText, Briefcase, Target, MessageSquare, Brain, CheckCircle, AlertCircle, ExternalLink, Plus, X, Loader } from 'lucide-react';


const PageHeader = ({ 
interview,
setShowMockScheduleModal
 }) => {


return (
<div className="mb-8">

<div className="flex items-center justify-between mb-4">


<div className="flex items-center gap-4">
<button
onClick={() => window.history.back()}
className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
>
<ArrowLeft className="w-5 h-5" />
</button>
<div className="flex-1">
<div className="flex items-center gap-3 mb-2">
<img
src={interview.companyLogo}
alt={interview.company}
className="w-12 h-12 rounded-lg object-cover"
/>
<div>
<h1 className="text-2xl font-bold text-gray-900">{interview.jobTitle}</h1>
<p className="text-gray-600">{interview.company}</p>
</div>
</div>
<div className="flex flex-wrap items-center gap-4 text-sm text-gray-600">
<span className="flex items-center gap-1">
<Calendar className="w-4 h-4" />
{new Date(interview.date).toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' })}
</span>
<span className="flex items-center gap-1">
<Clock className="w-4 h-4" />
{interview.time}
</span>
<span className="flex items-center gap-1">
<MapPin className="w-4 h-4" />
{interview.interviewFormat}
</span>
</div>
</div>
</div>

<div className="hidden md:flex items-center space-x-3">

<Button
variant="default"
iconName="Brain"
iconPosition="left"
iconSize={16}
onClick={() => setShowMockScheduleModal(true)}
disabled={interview.mockPracticeSession?.scheduled}
className={`${
interview.mockPracticeSession?.scheduled
? 'bg-gray-300 text-gray-500 cursor-not-allowed'
: 'bg-purple-600 text-white hover:bg-purple-700'
}`}
>
{interview.mockPracticeSession?.scheduled ? 'Mock Interview Scheduled' : 'Schedule AI Mock Interview'}
</Button>


</div>


</div>
</div>
);
};

export default PageHeader;